import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageTabs, type PageTab } from "@components/CatalogIndex";
import useAccountHasEntitlement from "@common/hooks/useAccountHasEntitlement";
import "./VendorEditLayout.css";

export const VendorEditLayout = (): JSX.Element => {
  const { hasEntitlement } = useAccountHasEntitlement();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Active tab is derived from the sub-route so styling stays correct on direct
  // navigation/refresh, not just clicks.
  const activeKey = pathname.includes("/special_conditions")
    ? "special_conditions"
    : "vendor";

  const tabs: PageTab[] = [
    { key: "vendor", label: "Vendor" },
    ...(hasEntitlement("terms-and-conditions")
      ? [{ key: "special_conditions", label: "Terms & Conditions" }]
      : []),
  ];

  // Route-relative navigation resolves against this layout's route (`:id`).
  const handleSelect = (key: string) =>
    navigate(key === "vendor" ? "edit" : key);

  return (
    <div className="vendor-edit-layout">
      <PageTabs activeKey={activeKey} onSelect={handleSelect} tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default VendorEditLayout;
